module.exports = __webpack_public_path__ + "img/sample-yt-thumbnail.c86ba45f.png";